app.service('relatedPromotionCommercial', function (modal, loading, broker, front, pageConfig) {
	var productId, installment, installmentNumber;
	var lastModal = false;
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-modal-promotion-package', function () {
				productId = $(this).data('product');
				installment = $(this).data('installment') || undefined;
				installmentNumber = $(this).data('duration') || undefined;
				UA.interaction("Promocja wiązana", "Otwarcie warstwy");
				let $currentModal = $('.remodal.remodal-is-opened');
				if ($currentModal.length) {
					lastModal = $currentModal.attr('id');
				} else {
					lastModal = false;
				}
				load();
			}).on('click', '.js-add-promotion-package', function () {
				productId = $(this).data('product') || productId;
				var addedFrom = $(this).data('added-from');
				var relatedPromotionServiceId = $(this).data('related-promotion-service');
				if (modal.isOpen('promotion-package-modal')) {
					UA.interaction("Promocja wiązana", "Dodanie pakietu do koszyka z warstwy", addedFrom);
				} else {
					UA.interaction("Promocja wiązana", "Dodanie pakietu do koszyka", addedFrom);
				}

				loading.start();
				if (front.page() == 'basket') {
					logAddToCart(this);
				}
				$.ajax({
					url: '/add-related-promotion-to-cart.ltr',
					type: 'POST',
					data: {
						productId,
						relatedPromotionServiceId,
						addedFrom,
						replaceProduct: front.page() == 'basket' ? true : undefined
					},
					success: function (json) {
						if (json.cannotAddProductMessage) {
							modal.alert(json.cannotAddProductMessage);
						} else {
							broker.trigger('REFRESH_BASKET_VIEW');
						}
					},
					error: function () {
						modal.alert('Błąd dodawania pakietu do koszyka. Spróbuj ponownie później');
					}
				});
			});
		}
	}
	function logAddToCart(that) {
		let pId = $(that).data('product') / 1;
		let productData = pageConfig.getData('basket').items.filter((i) => i.id == pId);
		if (productData && productData.length && productData[0].promotionPackage) {
			let list = "Koszyk RWD";
			let products = [];
			if ($(that).closest('.product-box').length) {
				list = "Koszyk - lista produktów";
			} else if ($(that).closest('.services-list').length) {
				list = "Koszyk - lista usług";
			} else if ($(that).closest('#promotion-package-modal').length) {
				list = "Koszyk - warstwa szczegółów";
			}
			products.push({
				name: productData[0].promotionPackage.name,
				id: productData[0].promotionPackage.plu,
				price: productData[0].promotionPackage.price,
				category: "usługa",
				quantity: 1,
				dimension47: "zestaw usługowy",
				dimension48: productData[0].category
			});
			UA.push({
				event: "addToCart",
				ecommerce: {
					currencyCode: "PLN",
					add: {
						actionField: {
							list
						},
						products
					}
				}
			});
		}
	}
	function load() {
		if (productId / 1 > 0) {
			loading.start();
			$.ajax({
				url: '/related-promotion-details.ltr',
				data: {
					productId,
					instalmentCode: installment,
					instalmentNumber: installmentNumber
				},
				success: function (html) {
					loading.stop();
					modal.generate({
						id: 'promotion-package-modal',
						content: html,
						callbackClose: function () {
							if (lastModal) {
								modal.open(lastModal);
								lastModal = false;
							}
						}
					});
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd pobierania danych. Spróbuj ponownie później');
				}
			});
		} else {
			modal.alert('Błąd generowania warstwy. Spróbuj ponownie później');
		}

	}

	return {
		init
	}
});
